export default __webpack_public_path__ + "static/385-406-f2f2dae01411ffbd62d58813a7a3d8d7.jpg";